import React from 'react'

const AdminChefFinancials = () => {
    return (
        <h2>Chef Financials</h2>
    )
}

export default AdminChefFinancials
